<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg" id="nav">
      <a class="navbar-brand">ScholarLib</a>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link to="/" class="nav-link" exact>Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/upload/">Upload</router-link>
          </li>
        <template v-if="!isLoggedIn">
          <li class="nav-item">
            <router-link class="nav-link" to="/login">Login</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/signup">Sign Up</router-link>
          </li>
        </template>
        <template v-else>
          <li class="nav-item">
            <router-link class="nav-link" to="/feedback">Feedback</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/logout">Logout</router-link>
          </li>
        </template>
        </ul>
      </div>
    </nav>
    <router-view/>
    <footer class="footer">
    </footer>
  </div>
</template>

<script>
import firebase from 'firebase/app';

export default {
  data() {
    return {
      isLoggedIn: firebase.auth().currentUser !== null
    }
  },
  mounted() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.isLoggedIn = true;
      } else { //add this here for state changes
        this.isLoggedIn = false;
      }
    })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #007bff;
}

#nav a.router-link-active {
  color: #007bff;
}

.footer {
  background-color: #f5f5f5;
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
